import { Popup, Text } from '@wework/dieter-ui'
import React from 'react'
import ExampleCard from './ExampleCard'

export default function SATextHolder({
  title,
  text,
  example,
  style,
  type,
  value = '',
}: any) {
  return (
    <div style={style}>
      <Text size="small" color="black">
        {title}
      </Text>
      <Text size="tiny" style={{ color: '#666666' }}>
        {text}
      </Text>
      {example && (
        <Popup
          pinned
          on="click"
          trigger={
            <Text size="tiny" primary style={{ cursor: 'pointer' }}>
              Examples
            </Text>
          }
          style={{ padding: 0 }}
        >
          <ExampleCard type={type} value={value.toString().toUpperCase()} />
        </Popup>
      )}
    </div>
  )
}
